// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Keep inputs tidy */
.company-info form input,
.company-info form textarea {
  outline: none;
}

/* Optional: consistent hidden file input fallback */
.company-info input[type="file"].hidden { display: none; }
`, "",{"version":3,"sources":["webpack://./src/components/CompanyInfoPage.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;;EAEE,aAAa;AACf;;AAEA,oDAAoD;AACpD,0CAA0C,aAAa,EAAE","sourcesContent":["/* Keep inputs tidy */\n.company-info form input,\n.company-info form textarea {\n  outline: none;\n}\n\n/* Optional: consistent hidden file input fallback */\n.company-info input[type=\"file\"].hidden { display: none; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
